// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getRequestQuoteModalDataService, RequestQuoteApiParameter } from "@conklin/App/Services/RequestQuoteService";
import { xIsAuthenticated } from "@conklin/App/Store/Selectors/GeneralSelectors";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";

type HandlerType = ApiHandler<
    HasOnSuccess<RequestQuoteApiParameter> & HasOnError<string>,
    ServiceResult<RequestQuoteApiParameter>
>;

export const LoadCountries: HandlerType = props => {
    if (!getCurrentCountries(props.getState())) {
        props.dispatch(loadCurrentCountries());
    }
};

export const GetDataFromApi: HandlerType = async props => {
    props.apiResult = await getRequestQuoteModalDataService();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    const isAuthenticated = xIsAuthenticated(props.getState());
    if (props.apiResult.successful) {
        if (isAuthenticated) {
            props.dispatch({
                type: "xRequestQuote/update",
                data: {
                    ...props.apiResult.result,
                },
            } as any);
        }
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [LoadCountries, GetDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const xngGetQuote = createHandlerChainRunner(chain, "XngGetQuote");
export default xngGetQuote;
